import { cn } from "@/lib/utils";
import { Input } from "@backpac/monica";
import { type ComponentProps, forwardRef, useState } from "react";

interface PasswordInputProps extends ComponentProps<typeof Input> {}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ className, ...props }, ref) => {
  const [revealPassword, setRevealPassword] = useState(false);
  return (
    <div className={cn("relative", className)}>
      <Input ref={ref} type={revealPassword ? "text" : "password"} placeholder="Password" {...props} />
      <button
        type="button"
        tabIndex={-1}
        className={cn("absolute right-4 top-1/2 -translate-y-1/2 p-2", revealPassword ? "i-bp-eye" : "i-bp-eye-closed")}
        onClick={() => setRevealPassword((p) => !p)}
      />
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";
